// extracted by mini-css-extract-plugin
export default {"input":"xFOSR","field":"KEH3b"};